module.exports = __webpack_public_path__ + "assets/img/solar-collectors.da3b78a3.jpg";